import { dbPayload } from "../../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ ADDRESS VALIDATE (Dogma / Google Address Validation API relay)
 * addressLines: string[] - primary lookup key is [Address Line 1, Postcode]
 * regionCode: ISO2 country code (e.g. "GB")
 * Routed by X-INTENT "AddressValidate" - Doorman.cs sends this straight to
 * the Dogma Lambda, never touching nrgCore/SQL.
 */
export const validateAddress = async (addressLines, regionCode, config) => {
    const rawData = await dbPayload(
        "/api/v1/dogma/address-validate",
        "POST",
        config.siteKey,
        { action: "AddressValidate", payload: { addressLines, regionCode } },
        "AddressValidate"
    );

    if (!rawData?.success) {
        throw new Error(rawData?.message || "Address lookup failed.");
    }

    const postal = rawData.data?.result?.address?.postalAddress;
    if (!postal) {
        throw new Error("Address not found.");
    }

    const lines = postal.addressLines || [];
    return {
        addressLine1: lines[0] || "",
        addressLine2: lines.slice(1).join(", ") || "",
        town: postal.locality || "",
        county: postal.administrativeArea || "",
        postcode: postal.postalCode || "",
        country: postal.regionCode || regionCode,
    };
};
